import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-lg border transition-colors ${
        isDark 
          ? 'border-slate-700/50 bg-slate-800/50 hover:bg-slate-700/50' 
          : 'border-gray-300 bg-white hover:bg-gray-50'
      }`}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {isDark ? (
        <>
          <Sun size={16} className="text-amber-400" />
          <span className="text-xs text-slate-400">Light</span>
        </>
      ) : (
        <>
          <Moon size={16} className="text-indigo-600" />
          <span className="text-xs text-gray-700">Dark</span>
        </>
      )}
    </button>
  );
}
